import React from "react";
import "./First.css";
import { Container, Image } from "react-bootstrap";
import logo from "../../../../Asset/wo-logo (1) (5).png";
// import bigimg from "../../../../Asset/lifeatweb/15aug.jpg";

const First = () => {
  return (
    <>
      <section className="first-sec-lifeatweb">
        <Container>
          <div className="row life-at-row">
            <div className="col-xl-4 col-md-4 col-sm-12 life-at-col-1">
              <h1> Life@ </h1>
              <div className="wo-logo">
                <Image src={logo} className="w-100" />
              </div>
              <p class="hastag">#GreatWorkPlace </p>
              <p class="hastag">#WorkLifeBalance </p>
              <p class="hastag">#CreativeEnvironment </p>
            </div>
            <div className="col-xl-8 col-md-8 col-sm-12 life-at-col-2">
              <div className="life-at-img">
                {/* <img src={bigimg} alt="codeffien" className="w-100" /> */}
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
